export class BandLevel {
  key: string;
  name: any[] = [];
  usedByExit: boolean = false;
  usedByEngagement: boolean = false;
  usedByAssessment: boolean = false;
  isDeleted?: boolean;
  deletedBy?: string;
  deletionDate?: string;

}
